export default __webpack_public_path__ + "static/media/censorone.f61738f9.png";